import './TabStyles.css';

const AboutTab = ({ person }) => {
    const { profile } = person;

    return (
        <div className="about-tab">
            <section className="about-section">
                <h2 className="about-section__title">About me</h2>
                <p className="about-section__text" style={{whiteSpace:'pre-line'}}>{profile.bio}</p>
            </section>

            <section className="about-section">
                <h2 className="about-section__title">Qualifications & Certifications</h2>
                <div className="about-qualifications">
                    {profile.qualifications?.map((qual, index) => (
                        <div key={index} className="about-qualification">
                            <div className="about-qualification__icon">🎓</div>
                            <div className="about-qualification__content">
                                <h3 className="about-qualification__title">{qual.title}</h3>
                                <p className="about-qualification__meta">
                                    {qual.institution} • {qual.year}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="about-section">
                <h2 className="about-section__title">Specializations</h2>
                <div className="about-tags">
                    {profile.specializations.map((spec, index) => (
                        <span key={index} className="about-tag">{spec}</span>
                    ))}
                </div>
            </section>

            {/* <section className="about-section">
                <h2 className="about-section__title">Services Offered</h2>
                <div className="about-services">
                    {person.services.map(service => (
                        <div key={service.id} className="about-service">
                            <div className="about-service__info">
                                <h3 className="about-service__name">{service.name}</h3>
                                <p className="about-service__desc">{service.description}</p>
                            </div>
                            <div className="about-service__price">
                                ${service.price}/{service.period}
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}

            <section className="about-section">
                <h2 className="about-section__title">Languages</h2>
                <div className="about-languages">
                    {profile.languages.map((lang, index) => (
                        <span key={index} className="about-language-tag">{lang}</span>
                    ))}
                </div>
            </section>

            <section className="about-section">
                <h2 className="about-section__title">Accolades</h2>
                <p className="about-section__text about-section__text--highlight">
                    {person.accolades}
                </p>
            </section>
        </div>
    );
};

export default AboutTab;
